import { withFormik } from "formik";
import { UserFormFields } from "./UserFormFields";
import { updateTherapistAvailable } from "../../service/therapits-service";
import { user } from "../utils/auth";
import { errorMessageText } from "../../lib/constants";

const defaultErrorMessage = errorMessageText.default;

export const extractValidationErrors = (data) => {
  if (!data || typeof data !== 'object') return [];
  
  const errorFields = ['accepted_terms', 'availability', 'qualified_to_assist'];
  
  return errorFields.reduce((errors, field) => {
    if (data[field] && Array.isArray(data[field])) {
    errors.push(...data[field]);
    }
    return errors;
  }, []);
};

export const handleSubmit = async (values, { setSubmitting, setFieldError }) => {
  setSubmitting(true);

  try {
    const userData = user();

    const request = await updateTherapistAvailable(userData?.uid, {
      accepted_terms: values.accepted_terms,
      availability: values.availability,
      qualified_to_assist: values.qualified_to_assist,
    });

      global.Rollbar.info("Internship Success", {
        rollbarData: request,
      }); 

      window.location.href = "/";
  } catch (error) {
    setSubmitting(false);
    if (error.response) {
      const { data } = error.response;
      
      const validationErrors = extractValidationErrors(data);
      
      if (validationErrors.length > 0) {
        setFieldError("validation_errors", validationErrors);
      }
    } else {
      setFieldError("global_error", defaultErrorMessage);
      global.Rollbar.warning("Global Error", error.toJSON());
    }
  } finally {
    setSubmitting(false);
  }
};

export const UserForm = withFormik({
  enableReinitialize: true,
  mapPropsToValues: (props) => {
    return {
      qualified_to_assist: props.initialValues?.qualified_to_assist || false,
      availability: props.initialValues?.availability || "",
      accepted_terms: props.initialValues?.accepted_terms || false,
      global_error: "",
      global_success: "",
    };
  },
  handleSubmit,
  displayName: "UserForm",
})(UserFormFields);
